import type { RendererProps } from "../core/element-registry"
import { ElementRenderer } from "./element-renderer"
import { ButtonGroup } from "../components/ui/button-group"
import { cn } from "../lib/utils"

export function ButtonGroupRenderer({ element }: RendererProps) {
  const orientation = ((element as unknown as Record<string, unknown>).orientation ?? "horizontal") as
    | "horizontal"
    | "vertical"

  return (
    <ButtonGroup
      orientation={orientation}
      className={cn(element.className)}
      data-testid={`button-group-${element.id}`}
    >
      {element.children?.map((child) => (
        <ElementRenderer key={child.id} element={child} />
      ))}
    </ButtonGroup>
  )
}
